import type { NodeMock, StatePreset } from "../mock-types";

export const mapVoteMock: NodeMock = {
  label: "Map Vote",
  description: "Players vote on which map to play",
  state: (players) => ({
    votes: {
      [players[0]?.userId ?? ""]: "map_1",
      [players[1]?.userId ?? ""]: "map_3",
      [players[2]?.userId ?? ""]: "map_1",
    },
    voteCounts: { map_1: 2, map_2: 0, map_3: 1, map_4: 0, map_5: 0 },
    mapPool: ["map_1", "map_2", "map_3", "map_4", "map_5"],
    mapDetails: {
      map_1: { name: "Dust II", imageUrl: "https://picsum.photos/seed/dust2/640/360" },
      map_2: { name: "Mirage", imageUrl: "https://picsum.photos/seed/mirage/640/360" },
      map_3: { name: "Inferno", imageUrl: "https://picsum.photos/seed/inferno/640/360" },
      map_4: { name: "Ascent", imageUrl: "https://picsum.photos/seed/ascent/640/360" },
      map_5: { name: "Haven", imageUrl: "https://picsum.photos/seed/haven/640/360" },
    },
  }),
  config: {
    timeoutSeconds: 45,
    tiebreaker: "random",
    showVotes: "count_only",
    labels: {
      title: "Map Selection",
      subtitle: "Vote for the battlefield",
    },
  },
};

export const mapVotePresets: StatePreset[] = [
  {
    label: "No Votes",
    build: ({ defaultState }) => ({
      state: {
        ...defaultState,
        votes: {},
        voteCounts: { map_1: 0, map_2: 0, map_3: 0, map_4: 0, map_5: 0 },
      },
    }),
  },
  {
    label: "Heavy Voting",
    build: ({ players, defaultState }) => {
      const votes: Record<string, string> = {};
      const counts: Record<string, number> = { map_1: 0, map_2: 0, map_3: 0, map_4: 0, map_5: 0 };
      players.forEach((p, i) => {
        const mapId = i % 3 === 0 ? "map_1" : i % 3 === 1 ? "map_3" : "map_2";
        votes[p.userId] = mapId;
        counts[mapId]++;
      });
      return { state: { ...defaultState, votes, voteCounts: counts } };
    },
  },
  {
    label: "Finalized",
    build: ({ players, defaultState }) => {
      const votes: Record<string, string> = {};
      const counts: Record<string, number> = { map_1: 0, map_2: 0, map_3: 0, map_4: 0, map_5: 0 };
      players.forEach((p) => {
        votes[p.userId] = "map_1";
        counts.map_1++;
      });
      return { state: { ...defaultState, votes, voteCounts: counts, selectedMapId: "map_1" } };
    },
  },
];
